export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute[]
}
// obrmk 侧边栏导航
export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: {
        icon: 'vuestic-iconset-dashboard',
      },
    },
    {
      name: 'utm',
      displayName: 'menu.utm',
      meta: {
        icon: 'alternate_email',
      },
      children: [
        {
          name: 'utm-records',
          displayName: 'menu.utm-records',
        },
        {
          name: 'utm-components',
          displayName: 'menu.utm-components',
        },
        // {
        //   name: 'url-create',
        //   displayName: 'menu.url-create',
        // },
      ],
    },
    {
      name: 'company',
      displayName: 'menu.company',
      meta: {
        icon: 'group',
      },
      children: [
        {
          name: 'member',
          displayName: 'menu.members',
        },
        // {
        //   name: 'action-events',
        //   displayName: 'Action Events',
        // },
      ],
    },
    {
      name: 'support',
      displayName: 'menu.help',
      meta: {
        icon: 'help_center',
      },
    },
  ] as INavigationRoute[],
}
